import { useBaseMutation } from "../components/hooks/useBaseMutation"

export const usePlaceCartItemsOrders = () => {
    return useBaseMutation(
        'put',
        'https://api.menufy.link/dineIn/cartItems/order');
}